module.exports = __webpack_public_path__ + "img/MY.e2cfb998.png";